<template>
  <a
    :href="`https://www.rakumart.com/index.php?mod=goods&act=${product.type}&id=${product.iid}`"
    target="_blank"
  >
    <div class="product">
      <div class="pic">
        <img :src="product.pic" alt="" />
      </div>
      <div class="title">
        <p :title="product.title">{{ product.title }}</p>
        <div class="price">{{ product.price }}元</div>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
    },
    isMine: {
      type: Boolean,
    },
  },

  data() {
    return {};
  },
  computed: {
    product() {
      return JSON.parse(this.message.payload.description);
    },
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.product {
  display: flex;
  background-color: #fff;
  padding: 8px;
  border-radius: 10px;
  width: 260px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .pic {
    flex: 1;
    width: 65px;
    height: 65px;
    img {
      height: 60px;
    }
  }
  .title {
    height: 65px;
    flex: 4;
    line-height: 15px;
    padding: 0 5px;

    p {
      height: 45px;
      font-size: 12px;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      margin-bottom: 3px;
    }
  }
  .price {
    color: red;
    font-size: 15px;
  }
}
</style>